import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import api from "services/api";
import Spinner from "../../../elements/Spinner";
import Select from "react-select";
import Pagination from "../../../elements/Pagination";

import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { Button, Overlay, Popover } from "react-bootstrap";

export default function RequisitionsSpecial(props) {
  const params = useParams();
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [clickedIndex, setClickedIndex] = useState(null);
  const ref = useRef(null);
  const handlePurchaseDetailsClick = (event, index) => {
    setShow(clickedIndex !== index || !show);
    setTarget(event.target);
    setClickedIndex(index);
  };
  const userInfo = props.userData;
  console.log("USER", userInfo);
  const [spinner, setSpinner] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    () => Number(sessionStorage.getItem("currentPage")) || 1
  );
  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(0);
  const [total, setTotal] = useState(0);
  const [links, setLinks] = useState([]);

  const [filterData, setFilterData] = useState({
    from_date: "",
    to_date: "",
    status: sessionStorage.getItem("status") || "",
    item_id: "",
    searchValue: "",
  });
  const clearFields = () => {
    sessionStorage.removeItem("currentPage");
    sessionStorage.removeItem("selectedRequisition");
    sessionStorage.removeItem("status");
    setCurrentPage(1);
    setFilterData({
      from_date: "",
      to_date: "",
      status: "",
      item_id: "",
      searchValue: "",
    });
  };

  const filterChange = (name, value) => {
    setFilterData((prev) => {
      const newData = { ...prev, [name]: value };
      if (name === "status") {
        sessionStorage.setItem("status", value); // persist only status
      }
      return newData;
    });
  };

  // get all requisitions
  const [requisitions, setRequisitions] = useState([]);
  const getRequisitions = async () => {
    setSpinner(true);
    // Send the correct page parameter to the API request
    var response = await api.post("/requisitions/special?page=" + currentPage, {
      company_id: params.company_id,
      from_date: filterData.from_date,
      to_date: filterData.to_date,
      status: filterData.status,
      id: filterData.item_id,
      searchValue: filterData.searchValue,
    });

    if (response.status === 200 && response.data) {
      // Update the state with pagination data
      setRequisitions(response.data.requisitions.data);
      setLinks(response.data.requisitions.links);
      setFrom(response.data.requisitions.from);
      setTo(response.data.requisitions.to);
      setTotal(response.data.requisitions.total);
    } else {
      console.log(response.data);
    }
    setSpinner(false);
  };
  useEffect(() => {
    getRequisitions();
  }, [currentPage, filterData, params.company_id]);

  const listRef = useRef(null);

  useEffect(() => {
    const selectedRequisition = sessionStorage.getItem("selectedRequisition");
    if (selectedRequisition && listRef.current) {
      const itemElement = listRef.current.querySelector(
        `[data-id="${selectedRequisition}"]`
      );
      if (itemElement) {
        itemElement.scrollIntoView({ behavior: "smooth", block: "center" });
        itemElement.focus();
      }
    }
  }, [requisitions]);

  const handleItemClick = (id) => {
    sessionStorage.setItem("selectedRequisition", id);
    sessionStorage.setItem("currentPage", currentPage);
    history.push(`/requisitions-details/${id}`);
  };

  const selectedRequisition = sessionStorage.getItem("selectedRequisition");

  const [selectedItems, setSelectedItems] = useState([]);
  const handleCheckboxChange = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const handleDownload = async () => {
    if (!selectedItems.length) return;

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    let currentY = 10; // track vertical position

    setSpinner(true);

    for (let i = 0; i < selectedItems.length; i++) {
      const id = selectedItems[i];
      try {
        const res = await api.post("/requisitions-show", { id });
        const data = res.data.data;

        // --- Title ---
        pdf.setFontSize(9);
        pdf.text("FALGUN GROUP", pageWidth / 2, currentY, { align: "center" });
        currentY += 5;
        pdf.setFontSize(10);
        pdf.text("REQUISITION", pageWidth / 2, currentY, { align: "center" });
        currentY += 4;

        // --- Header Info Table ---
        pdf.autoTable({
          startY: currentY,
          theme: "grid",
          styles: { fontSize: 7, cellPadding: 0.8, halign: "left" },
          margin: { left: 14, right: 14 },
          tableWidth: "auto",
          body: [
            ["Requisition No", data.requisition_number],
            ["Date", moment(data.created_at).format("lll")],
            ["By", `${data.requisition_by} (${data.department_title})`],
            ["Vendor", data.company],
          ],
        });

        currentY = pdf.lastAutoTable.finalY + 2;

        // --- Totals ---
        const approxAmount = data.requisition_items.reduce(
          (sum, item) =>
            sum +
            (parseFloat(item.recommand_qty) || 0) *
              (parseFloat(item.rate) || 0),
          0
        );

        const finalAmount = data.requisition_items.reduce(
          (sum, item) =>
            sum +
            (parseFloat(item.final_qty) || 0) *
              (parseFloat(item.final_rate) || 0),
          0
        );

        // --- Items Table ---
        pdf.autoTable({
          startY: currentY,
          head: [
            [
              "SL",
              "Item",
              "Unit",
              "Inhand",
              "Req",
              "Recommended",
              "Audited",
              "Final",
              "Purchase",
              "Aprox Rate",
              "Final Rate",
              "Total",
              "Remarks",
            ],
          ],
          body: [
            ...data.requisition_items.map((item, index) => [
              index + 1,
              item.part_name,
              item.unit,
              item.stock_in_hand,
              item.qty,
              data.recommended_by > 0 ? item.recommand_qty : "",
              data.checked_by > 0 ? item.audit_qty : "",
              data.finalized_by > 0 ? item.final_qty : "",
              item.purchase_qty,
              item.rate,
              item.final_rate,
              item.total,
              item.remarks,
            ]),
            [
              "",
              "TOTAL",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              approxAmount.toFixed(2),
              finalAmount.toFixed(2),
              finalAmount.toFixed(2),
              "",
            ],
          ],
          styles: { fontSize: 7, cellPadding: 0.5 },
          headStyles: {
            fontSize: 7,
            fillColor: [40, 40, 40],
            textColor: [255, 255, 255],
          },
          theme: "grid",
          margin: { left: 14, right: 14 },
        });

        currentY = pdf.lastAutoTable.finalY + 5;

        // --- Signature Section ---
        const signatures = [
          {
            check: data.placed_by > 0,
            img: data.placed_by_sign,
            name: data.placed_by_name,
            date: data.placed_at,
            label: "Placed",
          },
          {
            check: data.rejected_by > 0,
            img: data.rejected_by_sign,
            name: data.rejected_by_name,
            date: data.rejected_at,
            label: "Rejected",
            color: "red",
          },
          {
            check: data.recommended_by > 0,
            img: data.recommended_by_sign,
            name: data.recommended_by_name,
            date: data.recommended_at,
            label: "Recommended",
          },
          {
            check: data.valuated_by > 0,
            img: data.valuated_by_sign,
            name: data.valuated_by_name,
            date: data.valuated_at,
            label: "Valuated",
          },
          {
            check: data.checked_by > 0,
            img: data.checked_by_sign,
            name: data.checked_by_name,
            date: data.checked_at,
            label: "Checked",
            color: "green",
          },
          {
            check: data.approved_by > 0,
            img: data.approved_by_sign,
            name: data.approved_by_name,
            date: data.approved_at,
            label: "Approved",
          },
          {
            check: data.finalized_by > 0,
            img: data.finalized_by_sign,
            name: data.finalized_by_name,
            date: data.finalized_at,
            label: "Finalized",
          },
        ];

        let x = 14;
        signatures.forEach((sig) => {
          if (sig.check) {
            if (sig.img) {
              pdf.addImage(sig.img, "PNG", x, currentY, 20, 15);
            }
            pdf.setFontSize(7);
            pdf.setTextColor("black");
            pdf.text(sig.name, x, currentY + 20);
            pdf.text(moment(sig.date).format("lll"), x, currentY + 25);
            if (sig.color) pdf.setTextColor(sig.color);
            pdf.text(sig.label, x, currentY + 30);
            pdf.setTextColor("black");

            x += 35; // next signature block horizontally
          }
        });

        currentY += 40; // leave space below signatures

        // --- Page break if needed ---
        if (currentY > pdf.internal.pageSize.getHeight() - 40) {
          pdf.addPage();
          currentY = 10;
        }

        // --- Separator line between requisitions ---
        if (i < selectedItems.length - 1) {
          pdf.setDrawColor(200);
          pdf.line(14, currentY, pageWidth - 14, currentY);
          currentY += 4;
        }
      } catch (err) {
        console.error("Error downloading requisition:", err);
      }

      await sleep(500);
    }

    pdf.save("Requisitions.pdf");
    setSelectedItems([]);

    setSpinner(false);
  };

  return (
    <div className="create_edit_page">
      {spinner && <Spinner />}
      <div className="create_page_heading">
        <div className="page_name">Requisitions</div>
      </div>

      <div className="datrange_filter non_printing_area">
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>From Date</label>
              <input
                value={filterData.from_date}
                name="from_date"
                className="form-control"
                type="date"
                onChange={(event) =>
                  filterChange("from_date", event.target.value)
                }
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>To Date</label>
              <input
                value={filterData.to_date}
                name="to_date"
                className="form-control"
                type="date"
                onChange={(event) =>
                  filterChange("to_date", event.target.value)
                }
              />
            </div>
          </div>

          <div className="col">
            <div className="form-group">
              <label>Status</label>
              <select
                value={filterData.status}
                className="form-select"
                name="status"
                onChange={(event) => filterChange("status", event.target.value)}
              >
                <option value="">All</option>
                <option value="Pending">Pending</option>
                <option value="Placed">Placed</option>
                <option value="Recommended">Recommended</option>
                <option value="Valuated">Valuated</option>
                <option value="Checked">Checked</option>
                {/* <option value="Approved">Approved</option> */}
                <option value="Finalized">Finalized</option>
                <option value="Rejected">Rejected</option>
              </select>
            </div>
          </div>

          <div className="col d-none">
            <div className="form-group">
              <label>Requisition Number</label>

              <Select
                placeholder="Select"
                value={
                  filterData.item_id
                    ? {
                        value: filterData.item_id,
                        label: `${
                          requisitions.find(
                            (item) => item.id === filterData.item_id
                          )?.requisition_number || ""
                        } | ${
                          requisitions.find(
                            (item) => item.id === filterData.item_id
                          )?.label || ""
                        }`,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  filterChange("item_id", selectedOption.value)
                }
                name="item_id"
                options={requisitions.map((item) => ({
                  value: item.id,
                  label: `${item.requisition_number} | ${item.label}`,
                }))}
              />
            </div>
          </div>

          <div className="col">
            <div className="form-group">
              <label>Requisition Number</label>
              <input
                type="number"
                value={filterData.searchValue}
                className="form-control"
                name="searchValue"
                onChange={(event) =>
                  filterChange("searchValue", event.target.value)
                }
              />
            </div>
          </div>
          <div className="col-1">
            <br />
            <button onClick={clearFields} className="btn btn-warning btn-sm">
              <i className="fas fa-retweet"></i>
            </button>{" "}
          </div>
          {selectedItems.length > 0 ? (
            <div className="col">
              <br />
              <button
                onClick={handleDownload}
                className="btn btn-primary btn-sm"
              >
                Download
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <div className="table-responsive">
        <table ref={listRef} className="table substore_dataTable">
          <thead className="">
            <tr>
              <th className="text-center">
                <input
                  type="checkbox"
                  onChange={(e) =>
                    setSelectedItems(
                      e.target.checked
                        ? requisitions.map((item) => item.id)
                        : []
                    )
                  }
                  checked={
                    selectedItems.length === requisitions.length &&
                    requisitions.length > 0
                  }
                />
              </th>
              <th>SL</th>
              <th>Label</th>
              <th>Date</th>
              <th>Company</th>
              <th>Requisition By</th>
              <th>Status</th>
              <th>Stage</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {requisitions.map((item, index) => (
              <tr
                key={index}
                className={item.status}
                data-id={item.id}
                tabIndex={0}
              >
                <td
                  className={
                    selectedRequisition == item.id
                      ? "selected_border text-center"
                      : "text-center"
                  }
                >
                  <input
                    type="checkbox"
                    checked={selectedItems.includes(item.id)}
                    onChange={() => handleCheckboxChange(item.id)}
                  />
                </td>
                <td>{item.requisition_number}</td>
                <td>{item.label}</td>
                <td>{moment(item.created_at).format("lll")}</td>
                <td>{item.company}</td>
                <td>{item.requisition_by}</td>
                <td>{item.status}</td>
                <td>
                  {item.status === "Pending" && (
                    <div className="bg-danger zoomable_onlist">
                      Need to Place
                    </div>
                  )}
                  {item.status === "Placed" && (
                    <div className="bg-danger zoomable_onlist">
                      Waiting For Recommendation
                    </div>
                  )}
                  {item.status === "Recommended" && (
                    <div className="bg-danger zoomable_onlist">
                      Waiting For Purchase Valuation
                    </div>
                  )}

                  {item.status === "Valuated" && (
                    <div className="bg-danger zoomable_onlist">
                      Waiting For Audit Checking
                    </div>
                  )}

                  {item.status === "Checked" && (
                    <div className="bg-danger zoomable_onlist">
                      Waiting For Final Approval
                    </div>
                  )}
                  {item.status === "Finalized" && (
                    <>
                      {item.purchesed_items === 0 &&
                      item.partial_purchased === 0 ? (
                        <div className="text-white">Ready to Buy</div>
                      ) : (
                        <>
                          <Button
                            style={{
                              padding: 0,
                              fontSize: "12px",
                              zIndex: "9999",
                            }}
                            variant="light"
                            onClick={(e) =>
                              handlePurchaseDetailsClick(e, index)
                            }
                            className="d-inline-flex align-items-center"
                          >
                            <span className="ms-1">Show Purchase Details</span>
                          </Button>
                          <Overlay
                            show={show && clickedIndex === index}
                            target={target}
                            placement="bottom"
                            container={ref.current}
                            containerPadding={20}
                          >
                            <Popover
                              style={{ padding: 0, fontSize: "12px" }}
                              id="popover-contained"
                            >
                              <Popover.Header as="h3">
                                Purchase Details
                              </Popover.Header>
                              <Popover.Body>
                                <strong>Total Item:</strong> {item.total_items}
                                <br />
                                <strong>Purchased:</strong>{" "}
                                {item.purchesed_items} (
                                {item.purchase_percentage}%)
                                <br />
                                <strong>Partial Purchased:</strong>{" "}
                                {item.partial_purchased} (
                                {item.partial_purchase_percentage}%)
                                <br />
                                <strong>Not Purchased Yet:</strong>{" "}
                                {item.left_purchase_items}
                              </Popover.Body>
                            </Popover>
                          </Overlay>
                        </>
                      )}
                    </>
                  )}
                </td>
                <td>
                  <Link
                    onClick={() => handleItemClick(item.id)}
                    className="btn btn-warning btn-sm me-2"
                  >
                    Details
                  </Link>

                  {userInfo.userId === item.user_id &&
                  (item.status === "Pending" || item.status === "Rejected") ? (
                    <Link
                      className="btn btn-warning btn-sm"
                      to={"/requisitions-edit/" + item.id}
                    >
                      <i className="fa fa-pen"></i>
                    </Link>
                  ) : null}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <br />
        <h6 className="text-center">
          Showing {from} To {to} From {total}
        </h6>
        <Pagination
          links={links}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />
      </div>

      <br />
      <br />
    </div>
  );
}
